import script from "./PoolFees.vue?vue&type=script&lang=ts&setup=true"
export * from "./PoolFees.vue?vue&type=script&lang=ts&setup=true"

import "./PoolFees.vue?vue&type=style&index=0&id=27b35f9e&scoped=true&lang=css"
import "./PoolFees.vue?vue&type=style&index=1&id=27b35f9e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b35f9e"]])

export default __exports__